import React, { useContext } from 'react';
import { Dialog } from '@reach/dialog';
import '@reach/dialog/styles.css';

import Section from '@atoms/Section/Section';

import { GlobalContext } from '@context/GlobalContext';

import './_SignupModal.scss';

function SignupModal(props) {
    const [globalState, setGlobalState] = useContext(GlobalContext);

    function closeLightbox() {
        setGlobalState((prevData) => ({
            ...prevData,
            newsletterModalIsOpen: false,
        }));
    }

    return (
        <>
            {globalState.newsletterModalIsOpen && (
                <Dialog onDismiss={() => closeLightbox()}>
                    <div className="SignupModal">
                        <Section container="short">
                            <div className="SignupModal--inner">
                                {props.children}
                            </div>
                        </Section>
                    </div>
                </Dialog>
            )}
        </>
    );
}

export default SignupModal;
